module.exports = __webpack_public_path__ + "images/bannerES-41f323a6ba1892a91d758a0e61cda192.png";